import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-datails',
    templateUrl: './datails.component.html',
    styleUrls: ['./datails.component.css'],
    standalone: false
})
export class DatailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
